<div>
    <div class="content">
      <img src="assets/logo/logo_error.png" alt="Logo d'erreur" />
      <p>Pour accéder au site, merci d'activer l'utilisation des pop-ups dans ton navigateur, puis actualise la page.</p>
      <p class="instruction-content" [innerHTML]="navigatorInstruction"></p>
      <button class="accept" (click)="fermerDialog()">J'ai activé les pop-ups et j'actualise</button>
    </div>
  </div>